import Icon from '../components/Icon.vue'

Icon.register({"image":{"width":512,"height":512,"paths":[{"d":"M464 448H48C21.5 448 0 426.5 0 400V112C0 85.5 21.5 64 48 64H464C490.5 64 512 85.5 512 112V400C512 426.5 490.5 448 464 448zM112 120C81.1 120 56 145.1 56 176S81.1 232 112 232 168 206.9 168 176 142.9 120 112 120zM64 384H448V272L360.5 184.5C355.8 179.8 348.2 179.8 343.5 184.5L208 320 152.5 264.5C147.8 259.8 140.2 259.8 135.5 264.5L64 336V384z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/image.js
// module id = rpnW
// module chunks = 0